/**
 * Progress Bar – dynamic 4-stage funnel indicator
 * Stages: 1=location  2=meals  3=delivery  4=checkout (always future)
 */
(function () {
  'use strict';

  var root = document.getElementById('progress-bar-header');
  if (!root) return;

  var currentStage = parseInt(root.getAttribute('data-stage'), 10) || 1;
  var isCollectionBar = root.classList.contains('pb-bar--collection');

  function getSavedZip() {
    try {
      return sessionStorage.getItem('cs_zip') || '';
    } catch (e) {
      return '';
    }
  }

  function getMenuRegionName() {
    var candidates = document.querySelectorAll('.cab__heading, .collection-hero__title, h1');
    for (var i = 0; i < candidates.length; i += 1) {
      var heading = candidates[i];
      var text = heading && heading.textContent ? heading.textContent.trim() : '';
      if (!text || /^title$/i.test(text)) continue;
      if (heading.offsetParent === null && !heading.classList.contains('cab__heading')) continue;
      return text.replace(/\s+Menu$/i, '');
    }

    var path = window.location.pathname.replace(/\/$/, '');
    if (path.indexOf('/collections/west') === 0) return 'Western Canada';
    if (path.indexOf('/collections/east') === 0) return 'Ontario';
    if (path.indexOf('/collections/quebec') === 0) return 'Quebec';
    if (path.indexOf('/collections/usa') === 0) return 'West Coast';
    return 'this';
  }

  function ensureLocationStatus() {
    if (!isCollectionBar) return null;

    var status = root.querySelector('.pb-location-status');
    if (status) return status;

    status = document.createElement('div');
    status.className = 'pb-location-status';
    status.innerHTML =
      '<span class="pb-location-status__text"></span>' +
      '<span class="pb-location-status__separator">|</span>' +
      '<a class="pb-location-status__change" href="#">Not your location?</a>';

    var changeBtn = status.querySelector('.pb-location-status__change');
    if (changeBtn) {
      changeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        if (typeof window.zcpShowPopup === 'function') {
          window.zcpShowPopup(getSavedZip());
        }
      });
    }

    root.insertBefore(status, root.firstChild);
    return status;
  }

  function updateLocationStatus() {
    var status = ensureLocationStatus();
    if (!status) return;

    var textEl = status.querySelector('.pb-location-status__text');
    if (!textEl) return;

    var zip = getSavedZip();
    var pin = document.createElement('span');
    pin.className = 'pb-location-status__pin';
    pin.textContent = '\uD83D\uDCCD ';

    textEl.innerHTML = '';
    textEl.appendChild(pin);

    if (zip) {
      textEl.appendChild(document.createTextNode('Delivering to '));
      var strongZip = document.createElement('strong');
      strongZip.textContent = zip;
      textEl.appendChild(strongZip);
      return;
    }

    textEl.appendChild(document.createTextNode("You're viewing the "));
    var strongRegion = document.createElement('strong');
    strongRegion.textContent = getMenuRegionName();
    textEl.appendChild(strongRegion);
    textEl.appendChild(document.createTextNode(' menu'));
  }

  /* ── Apply classes for a given stage number ─────────── */
  function render(stage) {
    currentStage = stage;
    root.setAttribute('data-stage', stage);

    var items = root.querySelectorAll('.pb-stage');
    var connectors = root.querySelectorAll('.pb-connector');
    var halfConnectors = root.querySelectorAll('.pb-connector-half');

    items.forEach(function (el) {
      var num = parseInt(el.getAttribute('data-stage-num'), 10);
      el.classList.remove('pb-stage--completed', 'pb-stage--current', 'pb-stage--future');

      if (num < stage) {
        el.classList.add('pb-stage--completed');
      } else if (num === stage) {
        el.classList.add('pb-stage--current');
      } else {
        el.classList.add('pb-stage--future');
      }
    });

    /* Full connectors: dark if the stage they lead INTO is completed or current */
    connectors.forEach(function (el) {
      var beforeNum = parseInt(el.getAttribute('data-connector-before'), 10);
      el.classList.remove('pb-connector--done');
      if (beforeNum <= stage) {
        el.classList.add('pb-connector--done');
      }
    });

    /* Half connectors: dark only on the CURRENT stage (extends halfway toward next) */
    halfConnectors.forEach(function (el) {
      var afterNum = parseInt(el.getAttribute('data-half-after'), 10);
      el.classList.remove('pb-connector-half--active');
      if (afterNum === stage) {
        el.classList.add('pb-connector-half--active');
      }
    });
  }

  /* ── Collection bar placement ───────────────────────────
     Desktop + mobile (cart closed): in page flow, above the collection grid.
     Mobile (cart open): right after csMobileToggle, inside the cart sidebar. */
  if (root.classList.contains('pb-bar--collection')) {
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var cartOpen = false;

    /* The element the collection hero stack sits above. The expandable
       call-outs banner (A/B variant) renders between the hero and the grid,
       and the progress bar must stay ABOVE it — so anchor to the call-outs
       section when it is present, and fall back to the grid when it is not
       (control theme, or any collection the call-outs are not enabled on).
       location-routing.js uses the same anchor for #locationMismatchBanner,
       which keeps the banner and the bar together as one card. */
    function collectionAnchor() {
      return (
        document.querySelector('.collection-callouts-section') ||
        document.getElementsByClassName('collection-grid-section')[0]
      );
    }

    /* The bar is server-rendered inside the header and then relocated, so it
       starts as .pb-bar--pending (display:none). Reveal only on the frame
       AFTER the move lands, so the browser never paints it in the pre-move
       position — otherwise it flashes low on the page and visibly jumps up. */
    var revealRaf = null;
    function reveal() {
      if (!root.classList.contains('pb-bar--pending')) return;
      if (revealRaf) return;
      revealRaf = requestAnimationFrame(function () {
        revealRaf = null;
        root.classList.remove('pb-bar--pending');
      });
    }

    /* In-flow placement above the collection grid (desktop look). */
    function placeAboveGrid() {
      var banner = document.getElementById('locationMismatchBanner');
      if (banner) {
        banner.after(root);
        root.classList.add('pb-bar--below-banner', 'pb-bar--with-location-banner');
        root.classList.remove('pb-bar--in-cart', 'pb-bar--in-mobile-cart');
        reveal();
        return true;
      }
      var grid = collectionAnchor();
      if (grid) {
        grid.before(root);
        root.classList.add('pb-bar--below-banner');
        root.classList.remove('pb-bar--in-cart', 'pb-bar--in-mobile-cart', 'pb-bar--with-location-banner');
        reveal();
        return true;
      }
      return false;
    }

    /* The cart step currently in view (the slider shows one step at a time). */
    function activeStepEl() {
      var track = document.getElementById('csStepsTrack');
      if (track && track.classList.contains('cs-at-step-2')) {
        var step2 = document.getElementById('csStep2');
        if (step2) return step2;
      }
      return document.getElementById('csStep1');
    }

    /* Mobile only: inject the bar at the top of the active cart step so it
       scrolls with the items (and follows the user across steps). */
    function placeInMobileCart() {
      var step = activeStepEl();
      if (!step) return false;
      step.insertBefore(root, step.firstChild);
      root.classList.add('pb-bar--in-mobile-cart');
      root.classList.remove('pb-bar--below-banner', 'pb-bar--with-location-banner', 'pb-bar--in-cart');
      reveal();
      return true;
    }

    /* Initial placement: always in-flow above the grid (cart closed). */
    if (!placeAboveGrid()) {
      var pbObserver = new MutationObserver(function () {
        if (placeAboveGrid()) pbObserver.disconnect();
      });
      pbObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        pbObserver.disconnect();
        /* Failsafe: never leave the bar permanently invisible if no anchor
           ever appeared — show it where it is rather than not at all. */
        reveal();
      }, 5000);
    }

    /* Mobile: follow the cart open/close state, and the active step. */
    if (isMobile) {
      document.addEventListener('cs:mobile-toggle', function (e) {
        cartOpen = !!(e.detail && e.detail.expanded);
        if (cartOpen) {
          placeInMobileCart();
        } else {
          placeAboveGrid();
        }
      });

      /* goToStep() fires this; re-home the bar into the now-active step. */
      document.addEventListener('progressbar:stage-change', function () {
        if (cartOpen) placeInMobileCart();
      });
    }
  }

  /* ── Initial render ─────────────────────────────────── */
  updateLocationStatus();
  render(currentStage);

  /* ── Listen for cart-sidebar delivery stage event ───── */
  document.addEventListener('progressbar:stage-change', function (e) {
    var newStage = e.detail && e.detail.stage;
    if (newStage && newStage >= 1 && newStage <= 4) {
      render(newStage);
    }
  });

  /* ── Public API ─────────────────────────────────────── */
  window.addEventListener('inspiredgo:zip-updated', updateLocationStatus);
  window.updateProgressBar = render;
})();

/**
 * Bottom offsets on mobile collection pages
 * Measures .collection-sidebar-wrapper height and writes --dixa-bottom-offset
 * so the Dixa chat widget sits above the cart pill + progress bar. Also writes
 * --collection-mobile-bottom-offset so page content can scroll above the fixed
 * mobile cart UI.
 */
(function () {
  'use strict';

  var docEl = document.documentElement;
  var BREATHING = 16;
  var PAGE_BREATHING = 24;

  function updateDixaOffset() {
    if (!window.matchMedia('(max-width: 767px)').matches) {
      docEl.style.removeProperty('--dixa-bottom-offset');
      docEl.style.removeProperty('--collection-mobile-bottom-offset');
      return;
    }
    var wrapper = document.querySelector('.collection-sidebar-wrapper');
    if (!wrapper) {
      docEl.style.removeProperty('--dixa-bottom-offset');
      docEl.style.removeProperty('--collection-mobile-bottom-offset');
      return;
    }
    // Skip while cart is expanded — wrapper covers the screen and Dixa sits behind it via z-index
    var sidebar = wrapper.querySelector('.cs-sidebar');
    if (sidebar && sidebar.classList.contains('cs-expanded')) return;

    var h = wrapper.getBoundingClientRect().height;
    if (h > 0) {
      docEl.style.setProperty('--dixa-bottom-offset', (h + BREATHING) + 'px');
      docEl.style.setProperty('--collection-mobile-bottom-offset', (h + PAGE_BREATHING) + 'px');
    }
  }

  updateDixaOffset();
  window.addEventListener('resize', updateDixaOffset);

  var wrapper = document.querySelector('.collection-sidebar-wrapper');
  if (wrapper && window.ResizeObserver) {
    new ResizeObserver(updateDixaOffset).observe(wrapper);
  }
})();
